import '../styles/components/list.css';

const ListHeader = ({ 
  headers, 
  showCheckbox, 
  onCheckAll, 
  isAllChecked, 
  isPartiallyChecked,
  columnWidths = null 
}) => {
  return (
    <div className="list-header">
      {showCheckbox && (
        <div 
          className={`list-cell ${columnWidths ? 'list-cell-fixed-width' : ''}`}
          style={columnWidths ? { width: '60px' } : {}}
        >
          <div
            className={`patrol-list-checkbox ${isAllChecked ? 'checked' : ''} ${isPartiallyChecked ? 'indeterminate' : ''}`}
            onClick={onCheckAll}
            title="전체 선택/해제"
          ></div>
        </div>
      )}
      {headers.map((header, index) => (
       <div 
          key={index} 
          className={`list-cell ${columnWidths ? 'list-cell-fixed-width' : ''}`}
          style={columnWidths ? { width: columnWidths[index] } : {}}
        >
          {header}
        </div>
      ))}
    </div>
  );
};

export default ListHeader;